import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { UploadComponent } from './componets/upload/upload.component';
import { UploadControl } from './controls/upload/upload.control';
import { MediaService } from './services/media.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
  ],
  declarations: [UploadComponent, UploadControl],
  providers: [MediaService],
  exports: [UploadComponent, UploadControl],
})
export class MediaModule {}
